// extracted by mini-css-extract-plugin
export default {"desi":"DesiHisabLogo_desi__s0lQU"};